import React from "react";

interface CurrencyToggleProps {
  baseCurrencyCode: string;
  localCurrencyCode: string;
  isLocalSelected: boolean;
  onChange: (isLocal: boolean) => void;
  testIdPrefix?: string;
}

const CurrencyToggle: React.FC<CurrencyToggleProps> = ({
  baseCurrencyCode,
  localCurrencyCode,
  isLocalSelected,
  onChange,
  testIdPrefix = "payment-currency-toggle",
}) => {
  const segmentClassName = (isSelected: boolean) =>
    `rounded-full px-2 py-0.5 text-base font-bold ${isSelected ? "bg-info-lighter text-primary-accessible" : "text-gray-40"}`;

  return (
    <div
      role="radiogroup"
      aria-label="payment currency"
      className="inline-flex items-center rounded-full border border-primary-accessible p-1"
    >
      <button
        type="button"
        role="radio"
        aria-checked={!isLocalSelected}
        className={segmentClassName(!isLocalSelected)}
        onClick={() => onChange(false)}
        data-testid={`${testIdPrefix}-usd`}
      >
        {baseCurrencyCode}
      </button>
      <button
        type="button"
        role="radio"
        aria-checked={isLocalSelected}
        className={segmentClassName(isLocalSelected)}
        onClick={() => onChange(true)}
        data-testid={`${testIdPrefix}-local`}
      >
        {localCurrencyCode}
      </button>
    </div>
  );
};

export default CurrencyToggle;
